/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A US gallon is about 3.785 liters, while a UK (imperial) gallon is about 4.546 liters — around 20% larger. Fuel economy or recipe figures in 'gallons' mean different volumes depending on the country, so check the source before converting or comparing numbers.`)
};

const es_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Un galón estadounidense es aproximadamente 3.785 litros, mientras que un galón del Reino Unido (imperial) es aproximadamente 4.546 litros — aproximadamente 20% más grande. Figuras de economía de combustible o recetas en 'galones' significan volúmenes diferentes dependiendo del país, así que verifica la fuente antes de convertir o comparar números.`)
};

const de_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Eine US-Gallone sind etwa 3.785 Liter, während eine britische (imperiale) Gallone etwa 4.546 Liter sind — rund 20% größer. Verbrauchs- oder Rezeptangaben in 'Gallonen' bedeuten je nach Land unterschiedliche Volumina — prüfen Sie also die Quelle, bevor Sie Zahlen umrechnen oder vergleichen.`)
};

const nl_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Een Amerikaanse gallon is ongeveer 3.785 liter, terwijl een Britse (imperiale) gallon ongeveer 4.546 liter is — ongeveer 20% groter. Brandstofeconomie- of receptfiguren in 'gallons' betekenen verschillende hoeveelheden afhankelijk van het land, dus controleer de bron alvorens te converteren of getallen te vergelijken.`)
};

const fr_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Un gallon américain est environ 3,785 litres, tandis qu'un gallon britannique (impérial) est environ 4,546 litres — environ 20 % plus grand. Les chiffres d'économie de carburant ou de recette en 'gallons' signifient des volumes différents selon le pays, alors vérifiez la source avant de convertir ou de comparer les nombres.`)
};

const it_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Un gallone USA è circa 3,785 litri, mentre un gallone britannico (imperiale) è circa 4,546 litri — circa il 20% più grande. Le cifre di consumo di carburante o ricette in 'galloni' significano volumi diversi a seconda del paese, quindi controlla la fonte prima di convertire o confrontare i numeri.`)
};

const pt_br2_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Um galão US é cerca de 3.785 litros, enquanto um galão UK (imperial) é cerca de 4.546 litros — cerca de 20% maior. Figuras de economia de combustível ou receitas em 'galões' significam volumes diferentes dependendo do país, então verifique a fonte antes de converter ou comparar números.`)
};

const pt_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Um galão americano é cerca de 3,785 litros, enquanto um galão britânico (imperial) é cerca de 4,546 litros — aproximadamente 20% maior. Figuras de consumo de combustível ou receitas em 'galões' significam volumes diferentes dependendo do país, portanto verifique a fonte antes de converter ou comparar números.`)
};

const ja_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。米国ガロンは約3.785リットルで、英国(帝国)ガロンは約4.546リットル — 約20%大きいです。「ガロン」での燃料経済またはレシピの数字は国によって異なる体積を意味するため、数字を変換または比較する前にソースを確認します。`)
};

const zh_uc_vol_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq1_a", locale)
	if (locale === "en") return en_uc_vol_faq1_a(inputs)
	if (locale === "es") return es_uc_vol_faq1_a(inputs)
	if (locale === "de") return de_uc_vol_faq1_a(inputs)
	if (locale === "nl") return nl_uc_vol_faq1_a(inputs)
	if (locale === "fr") return fr_uc_vol_faq1_a(inputs)
	if (locale === "it") return it_uc_vol_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq1_a(inputs)
	if (locale === "pt") return pt_uc_vol_faq1_a(inputs)
	if (locale === "ja") return ja_uc_vol_faq1_a(inputs)
	return zh_uc_vol_faq1_a(inputs)
};